/* eslint-disable max-classes-per-file */

interface ImageSet {
  description: string;
  people: string;
  box: string;
  bg: string;
  bgColor: string;
}

export class KlubHomeData {
  klubId: number;

  title: string;

  slug: string;

  icon: string;

  color: string;

  desktop: ImageSet;

  mobile: ImageSet;

  constructor(data: any) {
    this.klubId = data.klubId || 0;
    this.title = data.title || "";
    this.slug = data.slug || "";
    this.icon = data.icon || "";
    this.color = data.color || "#444443";
    this.desktop = {
      description: data.desktop?.description || "",
      people: data.desktop?.people || "",
      box: data.desktop?.box || "",
      bg: data.desktop?.bg || "",
      bgColor: data.desktop?.bgColor || "",
    };
    this.mobile = {
      description: data.mobile?.description || "",
      people: data.mobile?.people || "",
      box: data.mobile?.box || "",
      bg: data.mobile?.bg || "",
      bgColor: data.mobile?.bgColor || "",
    };
  }
}

export class ResponseKlubHome {
  klub: KlubHomeData[];

  constructor(data: any) {
    this.klub = Array.isArray(data.klub)
      ? data.klub.map((item: any) => new KlubHomeData(item))
      : [];
  }
}
